import { useQuery } from "@tanstack/react-query";
import apiDal from "../config/apiDal";

export interface CategoryDimensionRow {
	CategoryDimension_ID: number;
	CategoryDimension_UID: string;
	ItemCategory_ID: string;
	Weight: number;
	IsTextbox: number;
	CreatedBy: string;
	CreatedDate: string;
	UpdatedBy: string | null;
	UpdatedDate: string | null;
	IsDeleted: number;
	Sequence: number;
	IsPublicRequired: number;
	IsBackofficeRequired: number;
	ChildCategoryLocalization: string;
	CategoryLocalization: string;
	"en-us": string;
	"de-ch": string;
	"de-de": string;
	"fr-fr": string;
	"it-it": string;
}

const fetchCategoryDimensions = async (portalId: number): Promise<CategoryDimensionRow[]> => {
	const response = await apiDal.post("/queries/fetch", {
		query: "getCategoryDimensions",
		bind: {
			portalId,
		},
	});

	return response.data.result;
};

export const useGetCategoryDimensions = ({ portalId }: { portalId: number }) => {
	return useQuery<CategoryDimensionRow[]>({
		queryKey: ["getCategoryDimensions", portalId],
		queryFn: () => fetchCategoryDimensions(portalId),
		enabled: !!portalId,
	});
};
